"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _states = require("@/api/master/states");
var _countries = require("@/api/master/countries");
// Assume these API functions exist
// For the dropdown
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _states.defaultStateData);
    this.loading = false;
    this.countries = []; // Holds country list for dropdown
    this.rules = {
      name: [{
        required: true,
        message: 'State name is required',
        trigger: 'blur'
      }, {
        max: 50,
        message: 'Length should be up to 50 characters',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: 'State code is required',
        trigger: 'blur'
      }, {
        len: 2,
        message: 'Code must be exactly 2 characters',
        trigger: 'blur'
      }],
      countryId: [{
        required: true,
        message: 'Please select a country',
        trigger: 'change'
      }]
    };
  }
  async created() {
    await this.fetchCountries();
    if (this.isEdit) {
      const id = this.$route.params.id;
      this.fetchData(+id);
    }
  }
  // Fetch countries for the dropdown
  async fetchCountries() {
    try {
      // Fetching all countries or a large limit to populate dropdown
      const res = await (0, _countries.getCountries)({
        limit: 1000,
        sort: 'name,ASC'
      });
      this.countries = res;
    } catch (error) {
      console.error('Failed to fetch countries', error);
    }
  }
  async fetchData(id) {
    try {
      const data = await (0, _states.getStateById)(id);
      Object.keys(this.formData).forEach(key => {
        this.$set(this.formData, key, data[key]);
      });
    } catch (error) {
      console.error('Failed to fetch state details', error);
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      // Ensure code is always uppercase
      if (this.formData.code) {
        this.formData.code = this.formData.code.toUpperCase();
      }
      if (this.isEdit) {
        await (0, _states.updateState)(this.formData.id, this.formData);
      } else {
        await (0, _states.createState)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'State saved successfully',
        type: 'success'
      });
      this.$router.push({
        name: 'States'
      });
    } finally {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'StateDetail'
})], default_1);
var _default = exports.default = default_1;